import React from "react";
import { useIntl } from "react-intl";
import Hero from "../components/Hero";
import LinkBox from "../components/LinkBox";

export type PIListLabsProps = {};

const PIListLabs: React.FC<PIListLabsProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={"/img/electronics-rs.jpg"}
        heading={intl.formatMessage({
          id: "public_info_6",
        })}
      />
      <div className="content">
        <div className="w-full flex flex-row flex-wrap justify-center">
          <div className="w-1/2 p-2">
            <LinkBox
              target="_blank"
              href="/pdf/labs/MCB-DLP-098 Catalogo de laboratorios.pdf"
              label={intl.formatMessage({
                id: "lab-cat",
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PIListLabs;
